import { defineComponent as _defineComponent } from 'vue'
import { useContext, onMounted, useRoute } from '@nuxtjs/composition-api';
import { Category } from '~/types/category';

interface Props {
  title?: string;
  description?: string;
  banner?: string;
  parent?: string | null;
  items?: Category[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryIndex',
  props: {
    title: { default: '' },
    description: { default: '' },
    banner: { default: '/images/banners/section-teaching-resources.png' },
    parent: { default: null },
    items: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { title: string, description: string, banner: string, parent: string | null, items: Category[] };

/* Category Index
 *
 * @parent:
 * @requests:
 * @events:
 * @props: String title, String description, String banner, Array items
 * @components:
 * @methods:
 */
const { $mzAnalyticsApi } = useContext();
const $route = useRoute();



function trackCategoryClick(name: string) {
  const analyticsName = name.replace(/\s+/g, '_');
  $mzAnalyticsApi({
    event: 'click',
    name: analyticsName,
    productArea: 'teaching-resource-collection',
  });
}

return { __sfc: true,$mzAnalyticsApi, $route, props, trackCategoryClick }
}

})